import { api } from "./client";

export interface Capabilities {
    send_test: boolean;
    ai: boolean;
    eden: boolean;
}

let cache: Capabilities | null = null;

export async function fetchCapabilities(): Promise<Capabilities> {
    if (cache) return cache;
    try {
        const me = await api.get<{ capabilities: Capabilities }>("/api/v1/me");
        cache = me.capabilities;
    } catch {
        cache = { send_test: false, ai: false, eden: false };
    }
    return cache;
}
